import { render } from "./ReportsWorkTask.vue?vue&type=template&id=0805e88a&scoped=true"
import script from "./ReportsWorkTask.vue?vue&type=script&lang=js"
export * from "./ReportsWorkTask.vue?vue&type=script&lang=js"

import "./ReportsWorkTask.vue?vue&type=style&index=0&id=0805e88a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0805e88a"]])

export default __exports__